import React from 'react'
import JobPosting from './jobPosting'
import { GoogleForJobs } from '../offers/offer/mapper'

type HeadProps = {
  title: string
  algoliaAppId?: string | null
  metaDescription: string
  metaTitle: string
  metaImage?: string
  linkCanonical?: string | null
  data?: GoogleForJobs
  noIndexing?: boolean
  keywords?: string
}

const Head: React.FC<HeadProps> = ({
  title,
  algoliaAppId = undefined,
  metaDescription,
  metaTitle,
  linkCanonical = undefined,
  data = undefined,
  metaImage = '/lamacompta-sharing-default.jpg',
  noIndexing = false,
  keywords = "comptabilité, cabinet comptable, emploi comptable, expert comptable, recrutement comptable",
}) => (
  <>
    <html lang="fr" />
    {algoliaAppId && (
      <link
        crossOrigin="anonymous"
        href={`https://${algoliaAppId}-dsn.algolia.net`}
        rel="preconnect"
      />
    )}
    <link rel="icon" href="/picto.svg" sizes="32x32" />
    <link rel="icon" href="/picto.svg" sizes="192x192" />
    <link rel="apple-touch-icon" href="/picto.svg" />
    <meta name="viewport" content="width=device-width, user-scalable=no" />
    <meta name="author" content="Lamacompta" />
    <meta name="description" content={metaDescription} />
    <meta name="title" content={metaTitle} />
    <meta name="keywords" content={keywords} />
    <meta property="og:title" content={metaTitle} />
    <meta property="og:url" content={linkCanonical || undefined} />
    <meta property="og:description" content={metaDescription} />
    <meta property="og:image" content={metaImage} />
    <meta property="og:site_name" content="Lamacompta" />
    <meta property="og:type" content="website" />

    <meta
      name="twitter:title"
      content={metaTitle || "Les Cabinets d'Expertise Comptable Préférés des Candidats sont Là ❤"}
    />
    <meta
      name="twitter:description"
      content={metaDescription || "Trouvez votre emploi en comptabilité. Collaborateur comptable, Juriste, Gestionnaire de paie, auditeur etc. en cabinet d'expertise comptable."}
    />
    <title>{title}</title>
    {linkCanonical && <link rel="canonical" href={linkCanonical} />}
    <JobPosting data={data || null} />
    {noIndexing && <meta name="robots" content="noindex" />}
  </>
)

export default Head
